"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var React = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var creatable_1 = __importDefault(require("react-select/creatable"));
var async_1 = __importDefault(require("react-select/async"));
var async_creatable_1 = __importDefault(require("react-select/async-creatable"));
var CustomRender_1 = require("./CustomRender");
var LabelTooltipDecorator_1 = __importDefault(require("../label-tooltip-decorator/LabelTooltipDecorator"));
var classnames_1 = __importDefault(require("classnames"));
// css baseclass prefix
var prefix = 'tk-select';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.getDropdownTag = function (asyncOptions, addNewOptions) {
            var DropdownTag = react_select_1.default;
            if (asyncOptions && !addNewOptions) {
                DropdownTag = async_1.default;
            }
            else if (asyncOptions && addNewOptions) {
                DropdownTag = async_creatable_1.default;
            }
            else if (!asyncOptions && addNewOptions) {
                DropdownTag = creatable_1.default;
            }
            return DropdownTag;
        };
        _this.handleChange = function (selectedOption, meta) {
            var isClearingTermSearch = _this.lastSelectedOption === _this.searchHeaderOption && !selectedOption;
            _this.lastSelectedOption = selectedOption;
            if (_this.props.onChange &&
                !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.searchHeader) &&
                !isClearingTermSearch) {
                _this.props.onChange({ target: { value: selectedOption } });
            }
            if (_this.props.onTermSearch && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.searchHeader)) {
                _this.props.onTermSearch(selectedOption);
            }
            if (meta.action === 'clear' && _this.props.onClear) {
                _this.props.onClear();
            }
        };
        _this.handleBlur = function () {
            var value = _this.props.value;
            if (_this.props.onBlur) {
                _this.props.onBlur({ target: { value: value } });
            }
        };
        _this.internalFiltering = _this.props.filterFunction
            ? function (o, input) { return _this.props.filterFunction(o.data, input); }
            : react_select_1.createFilter(null);
        _this.filter = function (o, input) {
            return o.data.searchHeader || _this.internalFiltering(o, input);
        };
        _this.handleIsOptionDisabled = _this.props.isOptionDisabled
            ? function (option) { return _this.props.isOptionDisabled(option); }
            : undefined;
        _this.handleIsOptionSelected = _this.props.isOptionSelected
            ? function (option) { return _this.props.isOptionSelected(option); }
            : function (option, selectValue) { return selectValue === null || selectValue === void 0 ? void 0 : selectValue.some(function (i) { return i === option; }); };
        _this.internalAsyncOptions = function (inputValue) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                return [2 /*return*/, (_a = this.props) === null || _a === void 0 ? void 0 : _a.asyncOptions(inputValue).then(function (options) { return new Promise(function (resolve) {
                        return resolve(_this.props.enableTermSearch ? __spread([_this.searchHeaderOption], options) : options);
                    }); })];
            });
        }); };
        _this.bindValue = _this.props.bindValue
            ? function (option) { return option[_this.props.bindValue]; }
            : undefined;
        _this.myRef = React.createRef();
        _this.searchHeaderOption = __assign({}, CustomRender_1.firstOption);
        var _a = _this.props, asyncOptions = _a.asyncOptions, addNewOptions = _a.addNewOptions, isMultiSelect = _a.isMultiSelect, hideSelectedOptions = _a.hideSelectedOptions, closeMenuOnSelect = _a.closeMenuOnSelect, displayArrowIndicator = _a.displayArrowIndicator;
        _this.state = {
            DropdownTag: _this.getDropdownTag(asyncOptions, addNewOptions),
            selectedOption: null,
            hideSelectedOptions: hideSelectedOptions || isMultiSelect,
            closeMenuOnSelect: closeMenuOnSelect || !isMultiSelect,
            displayArrowIndicator: displayArrowIndicator || !isMultiSelect,
        };
        return _this;
    }
    Dropdown.prototype.componentDidMount = function () {
        var _a = this.props, onInit = _a.onInit, value = _a.value;
        if (onInit && value) {
            onInit(value);
        }
    };
    Object.defineProperty(Dropdown.prototype, "internalOptions", {
        get: function () {
            var _a;
            if ((_a = this.props) === null || _a === void 0 ? void 0 : _a.options) {
                return this.props.enableTermSearch
                    ? __spread([this.searchHeaderOption], this.props.options) : this.props.options;
            }
        },
        enumerable: false,
        configurable: true
    });
    Dropdown.prototype.render = function () {
        var _a, _b;
        var _c = this.state, hideSelectedOptions = _c.hideSelectedOptions, closeMenuOnSelect = _c.closeMenuOnSelect, displayArrowIndicator = _c.displayArrowIndicator, DropdownTag = _c.DropdownTag;
        var _d = this.props, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        addNewOptions = _d.addNewOptions, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        asyncOptions = _d.asyncOptions, autoScrollToCurrent = _d.autoScrollToCurrent, bindLabel = _d.bindLabel, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        bindValue = _d.bindValue, blurInputOnSelect = _d.blurInputOnSelect, className = _d.className, defaultOptions = _d.defaultOptions, defaultValue = _d.defaultValue, enableTermSearch = _d.enableTermSearch, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        filterFunction = _d.filterFunction, iconName = _d.iconName, id = _d.id, inputAlwaysDisplayed = _d.inputAlwaysDisplayed, inputValue = _d.inputValue, isDisabled = _d.isDisabled, isInputClearable = _d.isInputClearable, isMultiSelect = _d.isMultiSelect, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isOptionDisabled = _d.isOptionDisabled, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isOptionSelected = _d.isOptionSelected, isTypeAheadEnabled = _d.isTypeAheadEnabled, label = _d.label, maxHeight = _d.maxHeight, maxMenuHeight = _d.maxMenuHeight, menuIsOpen = _d.menuIsOpen, menuPlacement = _d.menuPlacement, menuPortalStyles = _d.menuPortalStyles, menuPortalTarget = _d.menuPortalTarget, menuShouldBlockScroll = _d.menuShouldBlockScroll, menuShouldScrollIntoView = _d.menuShouldScrollIntoView, mode = _d.mode, name = _d.name, noOptionMessage = _d.noOptionMessage, placeHolder = _d.placeHolder, helperText = _d.helperText, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onBlur = _d.onBlur, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange = _d.onChange, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onClear = _d.onClear, onCopy = _d.onCopy, onCut = _d.onCut, onDrag = _d.onDrag, onFocus = _d.onFocus, onInputChange = _d.onInputChange, onKeyDown = _d.onKeyDown, onKeyUp = _d.onKeyUp, onMenuOpen = _d.onMenuOpen, onMenuClose = _d.onMenuClose, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onTermSearch = _d.onTermSearch, optionRenderer = _d.optionRenderer, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        options = _d.options, showRequired = _d.showRequired, size = _d.size, tabSelectsValue = _d.tabSelectsValue, tagRenderer = _d.tagRenderer, termSearchMessage = _d.termSearchMessage, tooltip = _d.tooltip, tooltipCloseLabel = _d.tooltipCloseLabel, value = _d.value, variant = _d.variant, otherProps = __rest(_d, ["addNewOptions", "asyncOptions", "autoScrollToCurrent", "bindLabel", "bindValue", "blurInputOnSelect", "className", "defaultOptions", "defaultValue", "enableTermSearch", "filterFunction", "iconName", "id", "inputAlwaysDisplayed", "inputValue", "isDisabled", "isInputClearable", "isMultiSelect", "isOptionDisabled", "isOptionSelected", "isTypeAheadEnabled", "label", "maxHeight", "maxMenuHeight", "menuIsOpen", "menuPlacement", "menuPortalStyles", "menuPortalTarget", "menuShouldBlockScroll", "menuShouldScrollIntoView", "mode", "name", "noOptionMessage", "placeHolder", "helperText", "onBlur", "onChange", "onClear", "onCopy", "onCut", "onDrag", "onFocus", "onInputChange", "onKeyDown", "onKeyUp", "onMenuOpen", "onMenuClose", "onTermSearch", "optionRenderer", "options", "showRequired", "size", "tabSelectsValue", "tagRenderer", "termSearchMessage", "tooltip", "tooltipCloseLabel", "value", "variant"]);
        return (React.createElement("div", { className: classnames_1.default(className, 'tk-input-group', "tk-input-group--" + size, {
                'tk-input-group--disabled': isDisabled,
            }) },
            React.createElement(DropdownTag, __assign({ styles: {
                    menuPortal: function (base) { return (__assign(__assign({}, base), menuPortalStyles)); },
                    valueContainer: function (base) { return (__assign(__assign({}, base), { maxHeight: maxHeight + "px" })); },
                    input: function (base) { return (__assign(__assign({}, base), { margin: (size === 'small') ? '0 2px' : undefined, color: 'inherit' })); },
                    multiValue: function (base) { return (__assign(__assign({}, base), { margin: '0' })); }
                }, parentInstance: this, ref: this.myRef, selectRef: this.myRef, displayArrowIndicator: displayArrowIndicator, optionRenderer: optionRenderer, tagRenderer: tagRenderer, isClearable: isInputClearable, components: {
                    DropdownIndicator: CustomRender_1.DropdownIndicator,
                    Control: CustomRender_1.Control,
                    SingleValue: CustomRender_1.SingleValue,
                    Input: CustomRender_1.Input,
                    Option: CustomRender_1.DefaultOptionRenderer,
                    MultiValueContainer: CustomRender_1.MultiValueContainerOverride,
                    MultiValue: CustomRender_1.DefaultTagRenderer,
                    ClearIndicator: CustomRender_1.ClearIndicator,
                    MultiValueRemove: function () { return null; },
                    NoOptionsMessage: CustomRender_1.NoOptionsMessage,
                    MenuList: CustomRender_1.DropdownList,
                    LoadingIndicator: function () { return null; },
                    LoadingMessage: CustomRender_1.LoadingMessage
                }, defaultValue: defaultValue, id: id, name: name, className: classnames_1.default(prefix, (_a = {}, _a[prefix + "--" + variant] = variant, _a), (_b = {}, _b[prefix + "--" + size] = size, _b)), closeMenuOnSelect: closeMenuOnSelect, classNamePrefix: prefix, value: value, inputValue: inputValue, inputAlwaysDisplayed: inputAlwaysDisplayed, onChange: this.handleChange, onBlur: this.handleBlur, onCopy: onCopy, onCut: onCut, onDrag: onDrag, onFocus: onFocus, onInputChange: onInputChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, options: this.internalOptions, loadOptions: this.internalAsyncOptions, defaultOptions: defaultOptions !== undefined ? defaultOptions : true, hideSelectedOptions: hideSelectedOptions, placeholder: placeHolder, isMulti: isMultiSelect, isDisabled: isDisabled, iconName: iconName, noOptionMessage: noOptionMessage, filterOption: this.filter, isSearchable: isTypeAheadEnabled, isOptionDisabled: this.handleIsOptionDisabled, isOptionSelected: this.handleIsOptionSelected, menuPlacement: menuPlacement, maxMenuHeight: maxMenuHeight, mode: mode ? mode : 'aligned', autoScrollToCurrent: autoScrollToCurrent, menuIsOpen: menuIsOpen, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, tabSelectsValue: tabSelectsValue, enableTermSearch: enableTermSearch, termSearchMessage: termSearchMessage, getOptionValue: this.bindValue, getOptionLabel: bindLabel, blurInputOnSelect: blurInputOnSelect, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView }, otherProps)),
            React.createElement(LabelTooltipDecorator_1.default, { htmlFor: id, label: label, placement: 'top', tooltip: tooltip, tooltipCloseLabel: tooltipCloseLabel, showRequired: showRequired }),
            helperText && React.createElement("div", { className: "tk-input__helper" }, helperText)));
    };
    Dropdown.defaultProps = {
        isDisabled: false,
        isMultiSelect: false,
        addNewOptions: false,
        isInputClearable: false,
        isTypeAheadEnabled: true,
        autoScrollToCurrent: false,
        enableTermSearch: false,
        menuPlacement: 'auto',
        menuPortalStyles: {},
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: true,
        size: 'medium',
        bindLabel: function (option) { return option === null || option === void 0 ? void 0 : option.label; },
    };
    return Dropdown;
}(React.Component));
exports.Dropdown = Dropdown;
exports.default = Dropdown;
